import axios from "axios";
import CryptoJS from "crypto-js";

// Encrypt the server secret for API authentication
const encryptedSecret = CryptoJS.AES.encrypt(process.env.VUE_APP_SERVER_SECRET, process.env.VUE_APP_SERVER_ENCRYPTION_KEY).toString();

// Construct base URL properly for relative or absolute URLs
const baseURL = process.env.VUE_APP_SERVERIP && process.env.VUE_APP_SERVERPORT
  ? `${process.env.VUE_APP_SERVERIP}:${process.env.VUE_APP_SERVERPORT}`
  : '';

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true, // Include session cookies
  headers: {
    "Content-type": "application/json",
    "cust-server-secret": `${encryptedSecret}`
  }
});

class ZauiDataService {
    ping() {
        return http.post("/zaui/zaui-ping");
    }

    getBookingByDay(date) {
        var testDate = date.toISOString().slice(0, 10);
        return http.get(`/zaui/get-booking-by-day?date=${testDate}`);
    }

    getManifestByDay(date) {
        var testDate = date.toISOString().slice(0, 10);
        return http.get(`/zaui/get-date-manifest?date=${testDate}`);
    }

    checkZauiMapping(date) {
        var testDate = date.toISOString().slice(0, 10);
        return http.post(`/zaui/check-zaui-mapping?date=${testDate}`);
    }

    getStatuses(interval) {
        return http.get(`/zaui/zaui-statuses-${interval}`);
    }

    getGuestProfile(booking) {
        return http.post(`/zaui/get-guest-profile-by-booking`, booking);
    }

    getBookingByNumber(bookingNumber) {
        return http.post(`/zaui/get-booking-by-number`, { bookingNumber });
    }

    getStatus() {
        // Use public endpoint that doesn't require authentication
        return http.get(`/zaui-status`);
    }

    syncClientWithZaui(clientData) {
        return http.post(`/zaui/sync-client-with-zaui`, clientData);
    }

    forceSyncClientWithZaui(clientData) {
        return http.post(`/zaui/force-sync-client-with-zaui`, clientData);
    }

    getSyncSettings() {
        return http.get(`/zaui/sync-settings`);
    }

    updateSyncSettings(settings) {
        return http.put(`/zaui/sync-settings`, settings);
    }
}

export default new ZauiDataService();
